import moment from 'moment';
import { UserSettings } from '../../components/ServiceMap/ServiceMap';
import { getAppContext } from './app';
import { getJSON, storeJSON } from './localStorage';
import { getLanguage } from './settings';

export enum USER_STATUS {
    ACTIVE = 1,
    SEMI_PASSIVE,
    PASSIVE
}

export enum USER_STATE {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    REGISTERED = 'REGISTERED'
}

export type UserType = {
    Abbr: string;
    Access: any;
    Created: string;
    Email: string;
    Firstname: string;
    LastUpdate: string;
    Lastname: string;
    OrganizationAdmin: boolean;
    OwnOrganization: any;
    Phone: string;
    ProjectCount: number;
    SystemAdmin: boolean;
    Title: string;
    UserId: number;
    UserState: USER_STATE;
};

export type UsersWithAccess = {
    AccessUserType: any;
    User: UserType;
};

export const USER_EMPLOYEE_ROLE_TYPENAME = 'USER_ORG_EMPLOYEE';

export enum WIDGET_TEXT_TYPE {
    DESCRIPTION = 'DESCRIPTION',
    HEADER = 'HEADER',
    INFO = 'INFO'
}

export const getLoggedInUser = () => {
    const cntx = getAppContext();
    return cntx ? cntx.user : null;
};

export const IsSystemAdmin = (user: any): boolean => {
    return user && user.SystemAdmin ? true : false;
};

export const IsServiceUser = (user: any) => {
    let userOrganizationRoles = user?.UserOrganizationRole || [];
    let userIsServiceUser = userOrganizationRoles.some((role: any) => {
        return role?.UserOrganizationRoleType?.Name === 'USER_ORG_SERVICE_PERSON';
    });
    return userIsServiceUser;
};

export const IsOrganizationAdmin = (user: any): boolean => {
    return user && user.OrganizationAdmin ? true : false;
};

export const getUserMapSettings = (user: any) => {
    let currentLanguage = getLanguage();
    let userSettings: UserSettings = {
        language: currentLanguage
        // TODO: add settings from theme here
    };
    return userSettings;
};

export const isOptionEnabled = (user: any, option: any) => {
    return user?.UserOptions?.length > 0
        ? user.UserOptions.findIndex((item: any) => {
              return item?.Name.length > 0 && item.Name.toUpperCase() == option;
          }) >= 0
        : false;
};

export const getUserAbreviation = (item: any) => {
    if (item && item.Abbr && item.Abbr.length > 0) {
        return item.Abbr;
    } else {
        let firstname = item && item.Firstname ? item.Firstname : '-';
        const lastname = item && item.Lastname ? item.Lastname : '-';
        return (firstname[0] + lastname[0]).toUpperCase();
    }
};

export const isDefaultSuncscription = (subs: any) => {
    // TODO, fix where would we store the contatnt for default role ?
    return subs.Plan && subs.Plan.Name.toUpperCase() == 'STANDARD' && subs.Plan.Organization;
};

export const getUserCompany = (user: any) => {
    if (user && user.OwnOrganization) {
        return user.OwnOrganization;
    }
    return null;
};

export const getUserCompanyName = (user: any) => {
    const comp = getUserCompany(user);
    if (comp && comp.Name && comp.Name.length > 0) {
        return comp.Name;
    }

    return '-';
};

export const getUserPlanName = (user: any) => {
    if (user && user.UserInGroup && user.UserInGroup.length > 0) {
        for (let ii = 0; ii < user.UserInGroup.length; ii++) {
            const uig = user.UserInGroup[ii];
            if (uig && uig.UserGroup && uig.UserGroup.Subscription) {
                for (let uu = 0; uu < uig.UserGroup.Subscription.length; uu++) {
                    const subs = uig.UserGroup.Subscription[uu];
                    if (isDefaultSuncscription(subs)) {
                        return subs.Plan.Name;
                    }
                }
            }
        }
    }

    return 0;
};

export const getUserCompanyId = (user: any) => {
    const comp = getUserCompany(user);
    if (comp && comp.OrganizationId) {
        return comp.OrganizationId;
    }
    return 0;
};

export const getUserName = (user: any, defaultValue: string = '-') => {
    let userName = user && user.Firstname ? user.Firstname : '';
    userName = user && user.Lastname ? userName + ' ' + user.Lastname : userName;
    return userName.length > 0 ? userName : defaultValue;
};

export const getOtptionPrise_EUR = (array: any) => {
    for (let aa = 0; aa < array.length; aa++) {
        const aitem = array[aa];
        //todo fix me once we knoew the logic
        if (aitem && aitem.Currency && aitem.Currency == 'EUR') {
            return aitem.Value + ' €';
        }
    }

    return null;
};

const getWidgetText = (hed: any, type: WIDGET_TEXT_TYPE, lang = 'EN') => {
    if (hed && hed.length) {
        for (let ii = 0; ii < hed.length; ii++) {
            const hed_er = hed[ii];
            if (
                hed_er.LangCode == lang &&
                hed_er.WidgetTextType &&
                hed_er.WidgetTextType.Name &&
                hed_er.WidgetTextType.Name == type
            ) {
                return hed_er.Text;
            }
        }
    }
    return '';
};

export const getUserMenuOptions = (user: any) => {
    let ret: any = [];

    if (user?.UserOptions?.length > 0) {
        let fp = {} as any;
        let cunter = 0;

        for (let ii = 0; ii < user.UserOptions.length; ii++) {
            const uig = user.UserOptions[ii];
            const fg = uig.Group ? uig.Group : uig.Name;
            if (!(fg in fp)) {
                cunter = cunter + 1;
                fp[fg] = {
                    index: cunter,
                    views: []
                };
            }

            fp[fg].views.push(uig);
        }

        for (let i = 0; i < cunter + 1; i++) {
            Object.keys(fp).map((one: any) => {
                if (fp[one]?.index == i && fp[one].views.length) {
                    ret.push({
                        name: one,
                        views: fp[one].views
                    });
                }
            });
        }
    }

    return ret;
};

export const getUserOptions = (user: any) => {
    let ret: any = [];

    if (user?.UserOptions?.length > 0) {
        for (let ii = 0; ii < user.UserOptions.length; ii++) {
            const uig = user.UserOptions[ii];
            const hed_text = getWidgetText(uig.Header, WIDGET_TEXT_TYPE.HEADER);
            ret.push({
                subscriptionType: undefined,
                header: hed_text.length > 0 ? hed_text : uig.Name,
                planId: undefined,
                price: '',
                name: uig.Name,
                optionId: uig.OptionId,
                active: true
            });
        }
    }

    return ret;
};

export const getUserRoles = (item: any) => {
    let roles = [];

    for (let ind = 0; ind < item.length; ind++) {
        const role = item[ind];
        if (role && role.UserOrganizationRoleType && role.UserOrganizationRoleType.Name) {
            let name: string = role?.Organization?.Name || '-';

            roles.push({
                name: role.UserOrganizationRoleType.Name,
                UserOrganizationRoleTypeId:
                    role.UserOrganizationRoleType.UserOrganizationRoleTypeId,
                OrganizationId: role.Organization?.OrganizationId
                    ? role.Organization.OrganizationId
                    : -1,
                organization: name
            });
        }
    }

    return roles;
};

const PINNDED_CARDS = 'PINNDED_CARDS';

export const getPinnedUserOptions = () => {
    const saved = getJSON(PINNDED_CARDS);
    return saved ? saved : [];
};

export const setPinnedUserOptions = (options: []) => {
    storeJSON(PINNDED_CARDS, options);
};
export const getPinnedOptionIndex = (pinned: [], planId: number, optionId: number) => {
    return pinned.findIndex((ed: any) => ed && ed.planId == planId && ed.optionId == optionId);
};

export const getOrderedOptions = (options: []) => {
    const orderCards = (oprions: any) => {
        const sorted = oprions.sort((a: any, b: any) => {
            const noValue = (it: any) => {
                if (!it) {
                    return true;
                } else if (it.pinIndex == undefined || it.pinIndex == null) {
                    return true;
                } else if (it.pinIndex < 0) {
                    return true;
                }
            };

            if (noValue(a) && noValue(b)) {
                return 0;
            } else if (noValue(a)) {
                return 1;
            } else if (noValue(b)) {
                return -1;
            }

            if (a.pinIndex == b.pinIndex) {
                // add Order here if it comes back
                return 0;
            }
            return a.pinIndex > b.pinIndex ? 1 : -1;
        });

        return sorted;
    };

    const newPinnedOptions = getPinnedUserOptions();
    let newOptions = [];
    if (options) {
        for (let oo = 0; oo < options.length; oo++) {
            const option = options[oo] as any;
            const findex = getPinnedOptionIndex(newPinnedOptions, option.planId, option.optionId);
            newOptions.push({ ...option, pinIndex: findex });
        }
    }

    return orderCards(newOptions);
};

export const getUserStatus = (user: any): USER_STATUS => {
    if (!user?.LastLogin) return USER_STATUS.PASSIVE;

    const lastLogin = new Date(user.LastLogin);
    const limit = moment().subtract(2, 'weeks').toDate();

    return lastLogin > limit ? USER_STATUS.ACTIVE : USER_STATUS.SEMI_PASSIVE;
};
